import React, { lazy } from 'react';

const DemoLazy = lazy(() => import('@/views/demo/DemoLazy'));
const DemoMemo = lazy(() => import('@/views/demo/DemoMemo'));
const DemoContext = lazy(() => import('@/views/demo/DemoContext'));
const DemoErrorBoundaries = lazy(() => import('@/views/demo/DemoErrorBoundaries'));
const DemoCreateRef = lazy(() => import('@/views/demo/DemoCreateRef'));
const DemoGetDerivedState = lazy(() => import('@/views/demo/DemoGetDerivedState'));

const demoRouteConfig = [{
  path: '/lazy',
  exact: true,
  component: () => <DemoLazy />,
}, {
  path: '/memo',
  exact: true,
  component: () => <DemoMemo />,
}, {
  path: '/context',
  exact: true,
  component: () => <DemoContext />,
}, {
  path: '/error',
  exact: true,
  component: () => <DemoErrorBoundaries />,
}, {
  path: '/ref',
  exact: true,
  component: () => <DemoCreateRef />,
}, {
  path: '/state',
  exact: true,
  component: () => <DemoGetDerivedState />,
}];

export default demoRouteConfig;
